import React from 'react'
import Page from 'components/Page/Page'
import QueueSettings from './Settings/QueueSettings'

const Queue = () => {
    return (
        <Page>
            <QueueSettings />
        </Page>
    )
}

export default Queue
